import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { DataService, HelperService, HTTPService } from 'app/services';
import { currency } from 'app/constants/currency.constants';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';

@Component({
  selector: 'app-ro-activity',
  templateUrl: './ro-activity.component.html',
  styleUrls: ['./ro-activity.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoActivityComponent implements OnInit {
  @Input() activity: any = {};
  @Input() code: string = '';
  @Input() invCode: string = '';

  @Output() openCustomerInSidepanel = new EventEmitter();
  @Output() openVehicleInSidepanel = new EventEmitter();
  @Output() openAttachmentTab = new EventEmitter();

  workStateTitle = {
    pause: 'Pause',
    inprogress: 'In progress',
    completed: 'Completed',
    new: 'Not Started',
  };
  usd: string = currency.USD;
  isFetchingPdf: boolean = false;
  isTransactionLookupActive: boolean = false;

  constructor(
    private dataService: DataService, 
    private httpService: HTTPService, 
    private helperService: HelperService, 
    private cdr: ChangeDetectorRef,
    private dialogService: DialogService,
    
  ) {}

  ngOnInit() {
    if (this.activity) {
      const { entityAction, data } = this.activity;

      if (entityAction === 'sent' && !data.hasPdf) {
        this.parseSentActivity();
      }
    }
  }

  handleOpenCustomerInSidepanel(customerId: string) {
    this.openCustomerInSidepanel.emit({ customerId });
  }

  handleOpenVehicleInSidepanel(customerId: string, vehicleId: string) {
    this.openVehicleInSidepanel.emit({ customerId, vehicleId });
  }

  handleOpenAppointment(appointmentId: string) {
    this.dataService.sendData(this.dataService.typeDialog('add-appointment', 'calendar-view', appointmentId, null, { _id: appointmentId }));
  }

  handleNewAttachmentClick(activity) {
    this.openAttachmentTab.emit(activity.entityTypeId);
  }

  parseSentActivity() {
    try {
      const text = this.activity.text || '';
      const start = '<a href="';
      const end = '">-PDF</a>';
      const startIndex = text.indexOf(start) + start.length;
      const endIndex = text.indexOf(end);

      const url = text.substring(startIndex, endIndex);
      const [key] = url.split('/').splice(4).join('/').split('?');

      this.activity.text = text.replace(/\<a href=.*?\-PDF\<\/a\>/gi, '');
      this.activity.data.hasPdf = true;
      this.activity.data.docKey = encodeURIComponent(key);
    } catch (err) {
      console.log('Failed to parse activity ==>>', err);
    }
  }

  async downloadSignedUrl(docId: string = '', docKey: string = '') {
    if (this.isFetchingPdf) return;

    this.isFetchingPdf = true;

    try {
      let url: string = '';

      if (docId) {
        url = await this.httpService.getDocumentById(docId);
      } else {
        url = await this.httpService.getDocumentByKey(docKey);
      }

      if (url) {
        window.open(url, '_blank');
      }
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.isFetchingPdf = false;
      this.cdr.detectChanges();
    }
  }
  async lookupTransaction(data: any) {
    const  {payloadToSend :{reference_id,payment:{amount}},estimate:{estimateId}}  = data;
    
    if (this.isTransactionLookupActive) return;

    this.isTransactionLookupActive = true;

    try {
      //404 means transaction not found
      //200 means transaction found but not added to repair order
      //201 means transaction found and added to repair order
      const transaction = await this.httpService.lookupTransaction(estimateId, reference_id, amount);
      if (transaction) {
        const { transactionStatus, apiResponse } = transaction;
        let message = ''
        let title = ''
        const buttons = {
          cancel: { title: `Cancel` },
        }
        if (transactionStatus === 404) {
          title = 'Payment not found in Global Payments';
          message = 'No record of this payment was found in Global Payments. The payment will not be added to the Repair Order.';
        } 
        else if (transactionStatus === 201) {
          title = 'Payment records are in sync';
          message = 'This payment is approved in Global Payments and is properly recorded on the Repair Order. No action is needed.';
        } 
        else if (transactionStatus === 200) {
          title = 'Payment approved in Global Payments but missing on the Repair Order';
          message = 'This payment has been approved in Global Payments, but does not exist on the Repair Order in Autoleap. Click "Sync Payment to Repair Order" to create this payment record in your system.';
          buttons['success'] = {
            title: 'Sync Payment to Repair Order',
            styleClass: 'btn-primary',
          }
        }

        const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
          width: '30%',
          styleClass: 'small-heading-dialog',
          showHeader: false,
          data: {
            styleClassHeading: 'font-14',
            title,
            message,
            button: buttons,
          },
        });

        const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
          if (isSuccess) {
            this.httpService.confirmLookupTransaction({ estimateId, apiResponse }).then((res) => {
              if (res) {
                this.helperService.showToaster('success', 'Payment recorded');
              }
            }).catch()
          }
          else {
            console.log('cancel');
          }
          onClose.unsubscribe();
        });
      }

    } catch (error) {
      this.helperService.showToaster('error', error);

    }
    finally {
      this.isTransactionLookupActive = false;
      this.cdr.detectChanges();
    }
  }
  getPaymentActivityText(code:string, data){
    const paymentStatus = data.isPaidFull ? 'Paid' : data.isPaidPartial ? 'Partially paid':'Unpaid';
    const text = `RO# ${code}: Payment Status was updated${data?.previousStatus ? ` from ${data?.previousStatus}`:''} to ${paymentStatus}`;
    return text;
  }
}
